import { useTheme } from "@mui/material";
import { LogOut } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import { useLogOut } from "web_myplann/Shared/Hooks/useLogOut";

type Props = {
	isLast?: boolean;
};

export const LogOutRow: FC<Props> = ({ isLast = false }) => {
	const theme = useTheme();
	const { t } = useResource();
	const { logOut } = useLogOut();

	return (
		<ListRow
			title={t(Resources.Settings.LogOut)}
			icon={<LogOut size={theme.iconSize.md} color={theme.palette.red[600]} />}
			iconBg={theme.palette.red[100]}
			destructive
			showChevron={false}
			isLast={isLast}
			onClick={logOut}
		/>
	);
};
